import { SdkError } from '../core/sdk-error'

export class RefreshTokenError extends SdkError {}
